import { ChevronLeft, UserCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const CheckoutHeader = () => {
  return (
    <motion.div
      className="flex items-center p-4 border-b sticky top-0 bg-white z-10 shadow-sm"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Link to="/store" className="flex items-center text-gray-600 hover:text-gray-800">
        <ChevronLeft className="w-5 h-5 mr-1" />
        <span className="text-sm">Back</span>
      </Link>

      <h1 className="text-lg font-semibold text-gray-800 mx-auto">Checkout</h1>

      <Link to="/profile" className="text-gray-600 hover:text-gray-800">
        <UserCircle className="h-6 w-6" />
      </Link>
    </motion.div>
  );
};

export default CheckoutHeader;
